var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboQuickTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.98 16.9097V12.6997H10.48C10.2 12.6997 9.97998 12.4797 9.97998 12.1997V11.1997C9.97998 10.9197 10.2 10.6997 10.48 10.6997H14.98V13.2897L20.36 8.6997L14.98 4.1097V6.6997H8.47998C8.19998 6.6997 7.97998 6.4797 7.97998 6.1997V5.1997C7.97998 4.9197 8.19998 4.6997 8.47998 4.6997H12.98V0.499703C12.98 0.0497034 13.52 -0.170297 13.83 0.149703L22.83 8.3597C23.03 8.5597 23.03 8.8697 22.83 9.0697L13.83 17.2797C13.52 17.5897 12.98 17.3697 12.98 16.9297V16.9097Z",
    fill: "#137FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.47998 10.7097H6.47998C6.20384 10.7097 5.97998 10.9336 5.97998 11.2097V12.2097C5.97998 12.4859 6.20384 12.7097 6.47998 12.7097H8.47998C8.75612 12.7097 8.97998 12.4859 8.97998 12.2097V11.2097C8.97998 10.9336 8.75612 10.7097 8.47998 10.7097Z",
    fill: "#137FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.47998 4.70972H4.47998C4.20384 4.70972 3.97998 4.93357 3.97998 5.20972V6.20972C3.97998 6.48586 4.20384 6.70972 4.47998 6.70972H6.47998C6.75612 6.70972 6.97998 6.48586 6.97998 6.20972V5.20972C6.97998 4.93357 6.75612 4.70972 6.47998 4.70972Z",
    fill: "#137FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.47998 4.70972H1.47998C1.20384 4.70972 0.97998 4.93357 0.97998 5.20972V6.20972C0.97998 6.48586 1.20384 6.70972 1.47998 6.70972H2.47998C2.75612 6.70972 2.97998 6.48586 2.97998 6.20972V5.20972C2.97998 4.93357 2.75612 4.70972 2.47998 4.70972Z",
    fill: "#137FFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.47998 10.7097H2.47998C2.20384 10.7097 1.97998 10.9336 1.97998 11.2097V12.2097C1.97998 12.4859 2.20384 12.7097 2.47998 12.7097H4.47998C4.75612 12.7097 4.97998 12.4859 4.97998 12.2097V11.2097C4.97998 10.9336 4.75612 10.7097 4.47998 10.7097Z",
    fill: "#137FFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboQuickTransfer);
export default __webpack_public_path__ + "static/media/FBOQuickTransfer.1e21e67e37571b3cb60a1857fa6c2b8d.svg";
export { ForwardRef as ReactComponent };